import { Category } from '@gripp/shared-logic';
import { Platform, StyleSheet, View } from 'react-native';
import { CategoryChip } from './categoryChip';
import { CategoryChipMenu } from './categoryChipMenu';

export const getCategoryColumn = (
  info: any,
  onPress: (categoryId: string) => Promise<void>,
  disabled = false
) => {
  const categories = info.getValue() as Category[];
  const isWeb = Platform.OS === 'web';

  if (!categories || categories.length === 0) return null;

  const onCategoryPress = !disabled ? onPress : undefined;
  const firstCategory = (
    <CategoryChip
      category={categories[0]}
      additionalStyle={[
        (isWeb && categories.length === 1) || !isWeb
          ? styles.firstCategoryChipOnly
          : styles.firstCategoryChip,
        { alignSelf: 'flex-start' },
      ]}
      onPress={onCategoryPress}
    />
  );

  const secondCategory = categories[1] ? (
    <CategoryChip
      category={categories[1]}
      additionalStyle={styles.firstCategoryChipOnly}
      onPress={onCategoryPress}
    />
  ) : null;

  const categoryMenu = (
    <CategoryChipMenu
      categories={categories}
      onPress={onCategoryPress}
      chipLength={
        !isWeb && categories.length > 2 ? categories.length - 1 : undefined
      }
    />
  );

  if (categories.length === 1) {
    return (
      <View style={{ flex: 1, flexDirection: 'row', gap: 1 }}>
        {firstCategory}
      </View>
    );
  }

  if (isWeb) {
    return (
      <View style={{ flex: 1, flexDirection: 'row', gap: 1 }}>
        {firstCategory}
        {categoryMenu}
      </View>
    );
  }

  if (categories.length === 2) {
    return (
      <View style={{ flexDirection: 'column', gap: 4 }}>
        {firstCategory}
        {secondCategory}
      </View>
    );
  }

  return (
    <View style={{ gap: 4 }}>
      {firstCategory}
      <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center' }}>
        <View style={{ maxWidth: 100 }}>{secondCategory}</View>
        {categoryMenu}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  firstCategoryChip: {
    marginRight: 5,
    maxWidth: '70%',
  },
  firstCategoryChipOnly: {
    marginRight: 5,
    maxWidth: '100%',
  },
});
